import React from 'react';
import { Accordion } from 'react-bootstrap';

interface InfoAccordionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const InfoAccordion: React.FC<InfoAccordionProps> = ({
  title,
  children,
  className,
}) => {
  return (
    <Accordion
      className={`border border-info rounded mb-3${className ? ` ${className}` : ''}`}
    >
      <Accordion.Item eventKey="0" className="bg-transparent">
        <Accordion.Header className="bg-info bg-opacity-10">
          <span className="text-info me-2">ℹ️</span>
          {title}
        </Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
